import {DomUtils, SystemUtils} from "@mecatran/utilities/src/index.web.mjs";

export class ListNavigation{
    constructor(getSelectableNodes){
        var _maxFocus;
        var _currentFocus = -1;     

        Object.defineProperty(this,'getSelectableNodes',{
            value : getSelectableNodes
        })

        Object.defineProperty(this,'maxFocus',{
            set : function(x){ _maxFocus = x },
            get : function(){ return _maxFocus }
        });

        Object.defineProperty(this,'next',{
            value : function(){  
                _currentFocus++;
                if ( _currentFocus > _maxFocus  ) _currentFocus = 0;
                if ( _currentFocus < 0 ) _currentFocus = _maxFocus; 
                this.updateActive();
            }
        });

        Object.defineProperty(this,'previous',{
            value : function(){
                _currentFocus--;
                if (_currentFocus > _maxFocus ) _currentFocus = 0;
                if (_currentFocus < 0) _currentFocus = _maxFocus;
                this.updateActive();
            }
        });

        Object.defineProperty(this,'currentFocus',{
            set : function(x){ _currentFocus = x },
            get : function(){ return _currentFocus }
        });
        
    }

    // ==========
    // public
    // ----------

    getCurrentFocus(){ return this.currentFocus }

    resetCurrentFocus(){ this.currentFocus = -1; }

    updateActive(){
        var nodes = this.getSelectableNodes();
        this.removeActive(nodes);
        this.addActive(nodes);
    }

    addActive(nodes) {
        var currentFocus = this.getCurrentFocus();
        /*a function to classify an item as "active":*/
        if (!nodes) return false;
        nodes[currentFocus].classList.add("active");
    }
    removeActive(nodes) {
        /*a function to remove the "active" class from all dropdown items:*/
        for (var i = 0; i < nodes.length; i++) {
          nodes[i].classList.remove("active");
        }
    }

    setMaxFocus(){
        this.maxFocus = this.getSelectableNodes().length - 1;
    }

    onKeyDown(event){
        if (event.keyCode == 40) {     // arrow Down pressed 
            this.next();
        } else if (event.keyCode == 38) { // arrow Up pressed 
            this.previous();
        } else if (event.keyCode == 13) { // enter
            event.preventDefault();
            var nodes = this.getSelectableNodes();
            if (nodes && this.currentFocus > -1 ) nodes[this.currentFocus].click(); 
        }
    }


    /* events for mouse hover */ 


    removeHover(){
        var nodes = this.getSelectableNodes();
        for (var i=0; i< nodes.length; i++){
            nodes[i].classList.remove("hover");
        }
    }

    onItemHover(event){ 
        this.removeHover();
        var selectableElement = DomUtils.getClosest('.selectable',event.target)
        if (selectableElement){
            selectableElement.classList.add("hover")
        }
    }

    onMouseLeave(event){
        this.removeHover();
    }

}



export class ListNavigationFeature{
    initListNavigation(parentNode){
        this.setFocusable(parentNode);
        this.setListNavigation();
        var listNavigation = this.getListNavigation();
        listNavigation.resetCurrentFocus();
        listNavigation.setMaxFocus();  
        var eventManager = this.getEventManager();
        eventManager.on('keydown', ()=>true, listNavigation.onKeyDown.bind(listNavigation), false);  // nav 
        eventManager.on('mouseover', ()=>true, listNavigation.onItemHover.bind(listNavigation), false);
        eventManager.on('mouseleave',()=>true, listNavigation.onMouseLeave.bind(listNavigation), false)
        this.updateManagerListeners();
    }

    setFocusable(node){ 
        node.setAttribute('tabindex','-1')
    }

    getHasNavigation(){ return (this.hasNavigation)}

    setHasNavigation(b){ this.hasNavigation = b; }

    getListNavigation(){ return this.listNavigation }

    setListNavigation(){
        var listNavigation = new ListNavigation(this.getSelectableNodes.bind(this));
        this.listNavigation = listNavigation;
    }

    getSelectableNodes(){ 
        var domManager = this.getDomManager();
        var nodes = domManager.getAllChildren('.selectable');
        return nodes;        
    }
}



